// src/pages/AboutUs.js
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Container, Typography, Box, Grid } from '@mui/material';

const AboutUs = () => {
  const { t, language } = useLanguage();

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom sx={{ 
        fontWeight: 'bold',
        textAlign: 'center',
        mb: 4
      }}>
        {t('about_us')}
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box sx={{ 
            p: 3,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 1,
            height: '100%'
          }}>
            <Typography variant="h5" gutterBottom sx={{ 
              fontWeight: 'bold',
              textAlign: language === 'ar' ? 'right' : 'left',
              mb: 2
            }}>
              {t('our_mission')}
            </Typography>
            <Typography variant="body1" sx={{ 
              textAlign: language === 'ar' ? 'right' : 'left',
              lineHeight: 1.8
            }}>
              {t('mission_description')}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box sx={{ 
            p: 3,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 1,
            height: '100%'
          }}>
            <Typography variant="h5" gutterBottom sx={{ 
              fontWeight: 'bold',
              textAlign: language === 'ar' ? 'right' : 'left',
              mb: 2
            }}>
              {t('our_vision')}
            </Typography>
            <Typography variant="body1" sx={{ 
              textAlign: language === 'ar' ? 'right' : 'left',
              lineHeight: 1.8
            }}>
              {t('vision_description')}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ 
            p: 4,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 1,
            mt: 2
          }}>
            <Typography variant="h5" gutterBottom sx={{ 
              fontWeight: 'bold',
              textAlign: language === 'ar' ? 'right' : 'left',
              mb: 3
            }}>
              {t('our_values')}
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {t('value_quality')}
                  </Typography>
                  <Typography variant="body1">
                    {t('value_quality_description')}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {t('value_innovation')}
                  </Typography>
                  <Typography variant="body1">
                    {t('value_innovation_description')}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {t('value_customer')}
                  </Typography>
                  <Typography variant="body1">
                    {t('value_customer_description')}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AboutUs;
